'use strict';

angular.module('shiftTraderApp')
  .directive('dayOffBar', function () {
    return {
      templateUrl: 'views/dayOffBar/dayOffBar.html',
      scope: {
        dayOff: '=dayOffBar'
      },
      bindToController: true,
      controllerAs: 'dayOffBar',
      controller: ['TimeService', 'ViewDayOffModalService', 'DaysOffManagementModalService', function(TimeService, ViewDayOffModalService, DaysOffManagementModalService) {
        var vm = this
        console.log('Day Off', vm.dayOff)

        vm.dayOff._mif = TimeService.minimalIntervalTimeFormat(vm.dayOff.range_twix)

        vm.openViewDayOffModal = function() {
          ViewDayOffModalService.openViewDayOffModal(vm.dayOff.id)
        }
      }]
    }
  })
